import Vue from 'vue';
import Vuex from 'vuex';
import { LeafletsStatus } from '@/store/modules/leaflets';

Vue.use(Vuex);

export default new Vuex.Store<LeafletsStatus>({
  mutations: {},
  actions: {},
  modules: {},
  plugins: []
});
